import { apiPlugin, StoryblokVue } from "@storyblok/vue"

export default defineNuxtPlugin(({ vueApp }) => {
  const config = useRuntimeConfig()
  vueApp.use(StoryblokVue, {
    accessToken: config.public.SB_ACCESS_TOKEN,
    apiOptions: {
      // cache: {
      //   type: "custom",
      //   custom: {
      //     flush() {
      //       console.log("all right")
      //     },
      //   },
      // },
    },
    use: [apiPlugin],
  })
})
